import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DictionaryACTypesDataService } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

@Component({
  selector: 'app-add-new-ac-type-dialog',
  templateUrl: './add-new-ac-type-dialog.component.html',
  styleUrl: './add-new-ac-type-dialog.component.scss',
})
export class AddNewAcTypeDialogComponent {
  newTypeForm: FormGroup;
  errorMessage?: string;

  constructor(
    public dialogRef: MatDialogRef<AddNewAcTypeDialogComponent>,
    private dataService: DictionaryACTypesDataService,
    private dialog: MatDialog
  ) {
    this.newTypeForm = new FormGroup({
      iataType: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(5),
          Validators.pattern('^[A-Za-z0-9]+$'),
        ],
      }),
      icaoType: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(5),
          Validators.pattern('^[A-Za-z0-9]+$'),
        ],
      }),
      tankCapacity: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(6),
          Validators.pattern('^[0-9]{1,6}$'),
        ],
      }),
      minOnBlockDiff: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(6),
          Validators.pattern('^-?\\d{1,6}$'),
        ],
      }),
      maxOnBlockDiff: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(7),
          Validators.pattern('^-?\\d{1,6}$'),
        ],
      }),
      sched: new FormControl(null, {
        validators: [
          Validators.maxLength(5),
          Validators.pattern('^[A-Za-z0-9]+$'),
        ],
      }),
      avgFuelConsPerBh: new FormControl(null, {
        validators: [
          Validators.maxLength(6),
          Validators.pattern('^[0-9]+$'),
        ],
      }),
    });
  }

  addNewType() {
    const request = this.newTypeForm.value;
    this.dataService.addType(request).subscribe({
      next: () => {
        this.dialogRef.close(this.newTypeForm.value);
      },
      error: (error) => {
        if (error || this.newTypeForm.invalid) {
          console.error(error.error.Message);
          this.errorMessage = error.error.Message;
          this.handleError(error);
        }
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
